import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent
} from '@mui/material';

const videos = [
  {
    title: 'Entrenamientos de futsal Selecion Argentina',
    url: 'https://www.youtube.com/embed/Xlze9y6ya_k?si=MsO6-R_cCum3G6zA',
  },
  {
    title: 'Entrenamientos de futsal Selecion Argentina parte 2',
    url: 'https://www.youtube.com/embed/vISz_nmgTM8?si=C7g2D1xj-ydw7VE7',
  },
  {
    title: 'Entrenamientos de futsal Selecion Argentina parte 3',
    url: 'https://www.youtube.com/embed/o7h1FCx6qsc?si=t72MsR6MUrMH5R09',
  },
];

const VideosLanding = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #06437c, #0a2239)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pt: 4,
        pb: 8,
      }}
    >
      <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold', mb: 3 }}>
        Últimos Videos
      </Typography>

      {videos.map((video, index) => (
        <Card
          key={index}
          sx={{
            width: '90%',
            maxWidth: 400,
            backgroundColor: 'white',
            borderRadius: 3,
            boxShadow: 6,
            mb: 3,
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {video.title}
            </Typography>
            <Box
              sx={{
                position: 'relative',
                paddingBottom: '56.25%',
                height: 0,
                overflow: 'hidden',
                borderRadius: 2,
              }}
            >
              <iframe
                src={video.url}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              ></iframe>
            </Box>
          </CardContent>
        </Card>
      ))}


    </Box>
  );
};

export default VideosLanding;
